import {streamGameAnalysis} from '@/Screens/ChessAnalysis/streamGameAnalysisApi';
import type {BrowserAnalysisMode} from '@/Screens/ChessAnalysis/browserGameAnalysis';
import {useMutation, UseMutationResult} from '@tanstack/react-query';
// import {streamGameAnalysis} from './streamGameAnalysisApi';

export type StreamGameAnalysisPayload = {
  gameId: number;
  mode?: BrowserAnalysisMode;
};

export function useStreamGameAnalysis(): UseMutationResult<
  any[],
  Error,
  StreamGameAnalysisPayload
> {
  return useMutation<any[], Error, StreamGameAnalysisPayload>(
    async (payload: StreamGameAnalysisPayload) => {
      return streamGameAnalysis(payload.gameId, payload.mode);
    },
  );
}
